export const appsFilterCategoryMap = {
    apps: "apps",
} as const;

export type FilterCategory = (typeof appsFilterCategoryMap)[keyof typeof appsFilterCategoryMap];
